import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Stato',
      fields: {
        delivery_visible: {
          label: 'Consegna visibile',
        },
        has_delivery: {
          label: 'Consegna',
        },
        delivery_enabled: {
          label: 'Consegna live',
        },
      },
    },
    delivery_mode: {
      title: 'Modalità consegna',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Flotta autisti del ristorante',
            [DeliveryMode.External]: 'Flotta autisti esterna ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Nota ritiro per il corriere',
          placeholder: "Informazioni utili per il ritiro del corriere (es. come trovare l'ingresso, ecc.)",
        },
        instant_print_enabled: {
          label: 'Stampa scontrino senza attendere il corriere',
        },
        provider_not_connected: {
          wolt_drive: 'Non ancora connesso: questo ristorante non ha un ID venue Wolt valido.',
          connects_on_external:
            '{{provider}} viene collegato quando la modalità di consegna è impostata su driver esterni e salvata.',
          not_connected_yet:
            '{{provider}} non è ancora collegato per questo ristorante. Se la situazione non cambia, contatta il supporto.',
        },
      },
    },
    scheduled_orders: {
      title: 'Ordini programmati',
      fields: {
        has_scheduled_orders: {
          label: 'Consenti ai clienti di ordinare in anticipo per orari specifici?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Tempo minimo (minuti) di anticipo per programmare ordini di <strong>consegna</strong>',
          placeholder: '60',
          validation_name: 'Tempo minimo di pianificazione consegna',
          external_hint: 'Con consegna esterna, deve essere almeno {{minutes}} minuti (2 ore). ',
        },
        last_order_gap_delivery: {
          label: 'Ultimo orario utile per ordinare la <strong>consegna</strong> (minuti prima della chiusura)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Info consegna',
      fields: {
        average_order_delivery_time_min: {
          label: 'Tempo di consegna',
          placeholder: 'Tempo in minuti',
        },
        average_order_delivery_time_max: {
          label: 'fino a',
          placeholder: 'Opzionale',
        },
      },
    },
    delivery_zones: {
      title: 'Zone di consegna',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    at_least_one_order_method_required:
      "Almeno 1 metodo d'ordine (programmato o immediato) deve essere attivo. Non puoi disabilitarli entrambi.",
  },
};
